import { ModalType } from 'common/common-models';
import React from 'react';
import { Button } from 'react-bootstrap';
import { ChargingReportConfiguration, ChargingReportConfigurationFilters } from './models';

interface ChargingReportConfigurationsSearchBarProps {
    filters: ChargingReportConfigurationFilters;
    onFilter: (filter: ChargingReportConfigurationFilters) => void;
    openChargingReportConfigurationModal: (modalType: ModalType, configuration?: ChargingReportConfiguration) => void;
}

export const ChargingReportConfigurationsSearchBar = (props: ChargingReportConfigurationsSearchBarProps) => {

    const onInputChange = (inputEvent: any) => {
        props.onFilter({
            search: inputEvent.target.value
        });
    };

    return (
        <div className="electricity-invoices__search-bar bar-position">
            <h2 className="text-light">
                Laadimisraportite seadistused
            </h2>
            <div className="card mb-5 shadow">
                <div className="card-body">
                    <div className="d-flex flex-wrap flex-sm-nowrap">
                        <input
                            placeholder="Jaama NOOM ID"
                            className='search-bar__input p-2'
                            onChange={onInputChange}
                            value={props.filters.search || ''}
                        />
                        <div className="d-flex flex-nowrap ml-auto">
                            <Button className="ml-auto d-flex align-items-center"
                                    onClick={() => props.openChargingReportConfigurationModal(ModalType.CREATE)}
                                    variant={"primary"}>
                                <i className="icon--16 icon__add d-flex mr-1"/>
                                <span>Lisa uus</span>
                            </Button>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    )
}